function _id(id) {
  return document.getElementById(id);
}

const form = _id("phone_number_login_form");
const phoneNumberInput = _id("customer_phone_number");
const phoneNumberFormErrorMessage = _id("phone-number-login-error-message");
const phoneNumberSubmitButton = _id("phone-number-login-submit-button");
const otpForm = _id("otp-form");
const errorText = _id("register-phone-error");

phoneNumberInput.addEventListener("input", (e) => {
  errorText.style.display = 'none';
  phoneNumberFormErrorMessage.innerHTML = "";

  phoneNumberSubmitButton.disabled = e.target.value.length !== 13;
});

const validation = () => {
  return phoneNumberInput.value.length !== 13;
};

phoneNumberSubmitButton.addEventListener("click", () => {
  const hasError = validation();

  if (hasError) {
    errorText.style.display = 'block';
    console.log('error phone');
  } else {
    sendOtpToPhoneNumber();
  }
});

const sendOtpToPhoneNumber = async () => {
  phoneNumberSubmitButton.disabled = true;
  const body = {
    phone: phoneNumberInput.value,
  };

  const config = {
    method: "POST",
    body: JSON.stringify(body),
    headers: {
      "Content-type": "application/json",
    },
  };

  const res = await fetch(
    "https://kidimart.uz/apps/kidimart/customer/login",
    config
  );

  const data = await res.json();

  phoneNumberSubmitButton.disabled = false;

  if (res.ok) {
    form.style.display = "none";
    otpForm.style.display = "block";
  } else {
    phoneNumberFormErrorMessage.innerHTML = data.data.message;
  }
};
